<div class="first-row" [style.justify-content]="justifyContent()">
	@if (!isDialog()) {
		<a class="home" routerLink="/welcome" mat-icon-button aria-label="Go to home page">
			<mat-icon class="logo">partner_exchange</mat-icon>
		</a>
	}
	@if (title()) {
		<h1>{{title()}}</h1>
	}
	<ng-content />
</div>

<div class="second-row">
	@defer (hydrate on interaction) {
		<div class="second-row-content" [class.is-hidden]="loading()">
			<ng-content select="[second-row-content]" />
		</div>
	}
	<div class="second-row-loader" [class.is-visible]="loading()">
		<div class="shimmer" aria-label="Loading" role="status"></div>
	</div>
</div>
